import api from './api'
import { parseParams, parseUrlFilters } from './common'

export default {
  async getAutocompletion ({ config, params, selection = [] }) {
    const method = config.method.toLowerCase()
    let pageUrl = `${config.url}?summary=1&${parseParams(params)}`
    if (config.extras) pageUrl = `${pageUrl}${config.extras}`
    const selectedUrl = selection.length && `${config.url}?summary=1&id__in=${selection.join()}`
    return Promise.all([
      api[method](pageUrl),
      selectedUrl ? api[method](selectedUrl) : Promise.resolve({ data: { results: [] } })
    ]).then(responses => {
      const [page, selectedFull] = responses
      const pageData = page.data.results
      const selectedData = selectedFull.data.results
      const filteredPage = pageData.filter(p => selection.indexOf(p.value) === -1)
      return selectedData.concat(filteredPage)
    })
  },
  getShops (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('shops', filters)
    return api.get(`/shops?${urlParams}&${urlFilters}`).then(res => res.data)
  },
  getShop ({ id, ...params }) {
    return api.get(`/shops/${id}?${parseParams(params)}`).then(res => res.data)
  },
  saveShop (shop) {
    const method = shop.id ? 'put' : 'post'
    const url = shop.id ? `/shops/${shop.id}` : '/shops'
    return api[method](url, shop).then(res => res.data)
  },
  saveShopBudget (shopid, body) {
    return api.put(`/shops/${shopid}/budget`, body).then(res => res.data)
  },
  getAdverts (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('adverts', filters)
    return api.get(`/adverts?${urlParams}&${urlFilters}`).then(res => res.data)
  },
  getAdvert ({ id, ...params }) {
    return api.get(`/adverts/${id}?${parseParams(params)}`).then(res => res.data)
  },
  getAdvertAvailability ({ id, availability = true, ...params }) {
    return api.get(`/adverts/${id}/availability?availability=${availability}&${parseParams(params)}`).then(res => res.data)
  },
  getAdvertAvailabilityList ({ availability = true, ...params }) {
    return api.get(`/adverts/availability?availability=${availability}&${parseParams(params)}`).then(res => res.data)
  },
  getAdvertAvailabilitySlots (id) {
    return api.get(`/adverts/${id}/availability/slots`).then(res => res.data)
  },
  checkAdvertAvailabilitySlots (id, body) {
    return api.post(`/adverts/${id}/availability/slots/check`, body).then(res => res.data)
  },
  saveAdvertAvailabilitySlots (id, body) {
    return api.post(`/adverts/${id}/availability/slots`, body).then(res => res.data)
  },
  removeAdvertAvailabilitySlots (id, slotId) {
    return api.delete(`/adverts/${id}/availability/slots/${slotId}`).then(res => res.data)
  },
  saveAdvert (advert) {
    const method = advert.id ? 'put' : 'post'
    const url = advert.id ? `/adverts/${advert.id}` : '/adverts'
    return api[method](url, advert).then(res => res.data)
  },
  getAdvertsFormats () {
    return api.get(`/adverts/formats`).then(res => res.data)
  },
  getAdvertsSizes () {
    return api.get(`/adverts/sizes`).then(res => res.data)
  },
  deleteAdvert (id) {
    return api.delete(`/adverts/${id}`).then(res => res.data)
  },
  getExclusivists () {
    return api.get(`/exclusivists?page_size=100`).then(res => res.data)
  },
  getPois (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('pois', filters)

    return api.get(`/pois?${urlParams}&${urlFilters}`).then(res => res.data)
  },
  getPoi ({ id, ...params }) {
    return api.get(`/pois/${id}?${parseParams(params)}`).then(res => res.data)
  },
  savePoi (poi) {
    const method = poi.id ? 'put' : 'post'
    const url = poi.id ? `/pois/${poi.id}` : '/pois'
    return api[method](url, poi).then(res => res.data)
  },
  deletePoi (id) {
    return api.delete(`/pois/${id}`).then(res => res.data)
  },
  getPoiCategories () {
    return api.get('/pois/categories').then(res => res.data)
  },
  getPostalCodes (params) {
    const urlParams = parseParams(params)
    return api.get(`/geo/postalcodes?${urlParams}`).then(res => res.data)
  },
  getGrids (params) {
    const urlParams = parseParams(params)
    return api.get(`/geo/geohashes?${urlParams}`).then(res => res.data)
  }
}
